import pIAnimation from '@assets/lottie/plug-intelligence.json'
import { AnimationPlayer } from '@components/AnimationPlayer'
import Touchable from '@components/Touchable'
import { PlugIntelligenceClient } from '@plug-core/clients/PlugIntelligenceClient'
import { ROUTES } from '@utils/routes'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const LLMChatButton = () => {
  const [isAvailable, setIsAvailable] = useState(false)

  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname === ROUTES.HOME) {
      PlugIntelligenceClient.isAvailable().then(setIsAvailable)
    }
  }, [])

  if (!isAvailable) return null

  return (
    <div className="absolute right-6 bottom-[60px] z-[4]">
      <Touchable
        onClick={() => navigate(ROUTES.LLM_CHAT)}
        scaleFactor={0.15}
        style={{ borderRadius: 999 }}
      >
        <div className="rounded-full bg-[image:var(--plug-grad-mark)] p-[3px] opacity-90">
          <div className="size-11 overflow-hidden rounded-full bg-bg opacity-[0.92]">
            <div className="absolute top-[-16px] left-[-33px] w-[115px]">
              <AnimationPlayer animationData={pIAnimation} />
            </div>
          </div>
        </div>
      </Touchable>
    </div>
  )
}
